var render = function (_h,_vm) {var _c=_vm._c;return _c('a',{class:[_vm.data.class, _vm.data.staticClass],attrs:{"href":("tel:" + (_vm.props.phoneNumber))}},[_vm._v("\n  "+_vm._s(_vm.props.phoneNumber)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }